import React, { Component } from 'react';
import MainTable from '../../../../common/table/MainTable';
import NewOccasionalSalary from './NewOccasionalSalary';
import * as columns from './OccasionalSalaryColumns';
import { tabs } from '../SalaryUtil';
import LinkTab from '../../../../common/tab/TabNav.js';
import { handlePost } from '../../../../../utils/AxiosUtil.js';
import { withSnackbar } from 'notistack';
import { getMessage } from '../../../../../utils/ErrorMessageTranslate';

class OccasionalSalary extends Component {

    state = {
        selectedFile: null,
    };

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "OCCASIONAL_SALARY";
            return item;
        })
        return data;
    }

    getCookies = () => {
        return [
            {
                name: 'occasionalSalaryAmount',
                label: 'Alkalmi fizetés összege',
                value: ''
            }
        ]
    }

    onChangeHandler = event => {
        this.setState({ selectedFile: event.target.files[0] })
    }

    onClickHandler = (event) => {
        console.log(event.target.files[0]);
        if (event.target.files[0]) {
            const data = new FormData();
            data.append('file', event.target.files[0]);
            const path = '/api/occasionalsalary-upload';
            handlePost(path, data, this);
        }
    }

    handleSuccess = (res) => {
        if (res.data) {
            console.log(res.data);
            /* eslint-disable array-callback-return */
            res.data.map(e => {
                this.props.enqueueSnackbar(e.params[0] + getMessage(e), { variant: e.severity.toLowerCase(), persist: true });
            })
        }
    }

    render() {
        return (
            <>
                <LinkTab tabs={tabs} index={1} />
                <MainTable
                    divClassName="salary"
                    tableName="Alkalmi Fizetések"
                    newObjectLabel="Új alkalmi fizetés hozzáadása"
                    path='/api/occasionalsalaries'
                    enrich={this.enrich}
                    columns={(refresh) => columns.columns(refresh)}
                    dialogContent={(refresh, close) => <NewOccasionalSalary refresh={refresh} close={close} />}
                    cookieObjects={this.getCookies()}
                    csvOnChangeHandler={this.onChangeHandler}
                    csvOnClickHandler={this.onClickHandler} />
            </>
        );
    }
}

export default withSnackbar(OccasionalSalary);